import React, { useState, useEffect } from 'react';
import { createTheme, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
const axios = require('axios');
const jwt = require('jsonwebtoken');

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    fontSize: '8em',
    color: 'white',
    backgroundColor: '#26477c',
  },
}));

const theme = createTheme({
  palette: {
    primary: { main: '#26477c' },
  },
});

const ProfilePage = ({ refreshData, setRefreshData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  let [userLists, setUserLists] = useState(false);
  let [userid, setUserID] = useState('');

  let history = useHistory();

  useEffect(() => {
    let authObj = Cookies.get('authObj');
    authObj = JSON.parse(authObj);
    let { token } = authObj;
    if (token) {
      jwt.verify(
        token,
        '6jFLnuPANxk4UzePcRSTRkwXSqxhAMf2FAm4VFvV',
        (err, decoded) => {
          setUserID(decoded.userid);
        }
      );
    }

    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
        apikey: 'jnjirej9reinvuiriuerhuinui',
      },
    };

    if (!userLists || refreshData) {
      axios
        .get(`${process.env.REACT_APP_API}/listOfUsers`, config)
        .then((response) => {
          setUserLists(response.data.userLists);
          setRefreshData(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    // if (refreshData) {
    //   window.location.reload();
    // }
  }, []);
  if (userLists) {
    let currentUser = userLists.find((user) => user.id === userid);
    let usertype = {
      admin: 'Adminstration Access',
      serviceUser: 'Corporate Access',
      user: 'Normal Access',
    };
    let { username, email, userType, organisation } = currentUser;
    let avatarLetter = username.split('');
    avatarLetter = avatarLetter[0];
    avatarLetter = avatarLetter.toUpperCase();

    let uType = usertype[userType];
    return (
      <>
        <ThemeProvider theme={theme}>
          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'left',
                backgroundColor: '#26477c',
                padding: '8px',
                borderRadius: '8px',
              }}
              item
              xs={12}>
              <span style={{ fontSize: '1.2em', color: 'white' }}>
                Basic Data &nbsp;
                <EditIcon
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    Cookies.set('page', `Edit Profile`);
                    history.push('/dashboard/editProfile');
                  }}
                  fontSize={'small'}
                />
              </span>
            </Grid>
          </Grid>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <div>&nbsp;</div>

          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '8px',
              }}
              item
              direction={'column'}
              xs={3}>
              <Avatar aria-label='recipe' className={classes.large}>
                {avatarLetter}
              </Avatar>
            </Grid>
            <Grid
              style={{
                display: 'flex',
                // justifyContent: 'left',
                padding: '8px',
              }}
              item
              direction='column'
              xs={2}>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>User Name</div>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>Access Level</div>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>Organisation</div>
            </Grid>
            <Grid
              style={{
                display: 'flex',
                // justifyContent: 'left',
                padding: '8px',
              }}
              item
              direction='column'
              xs={3}>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>{username}</div>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>{uType}</div>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>{organisation}</div>
            </Grid>
          </Grid>
          <div>&nbsp;</div>

          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '8px',
                // backgroundColor: 'gray',
              }}
              item
              direction={'row'}
              xs={2}>
              {/* <Button variant='contained'>Default</Button> */}
              <span
                style={{
                  marginRight: '0.8em',
                  cursor: 'pointer',
                }}>
                {/* <Button variant='contained'>
              Edit <StarBorder />
            </Button> */}
                {/*  */}
              </span>
            </Grid>
          </Grid>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'left',
                backgroundColor: '#26477c',
                padding: '8px',
                borderRadius: '8px',
              }}
              item
              xs={12}>
              <span style={{ fontSize: '1.2em', color: 'white' }}>
                Contact Details
              </span>
            </Grid>
          </Grid>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                // justifyContent: 'left',
                padding: '8px',
              }}
              item
              direction='column'
              xs={2}>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>Email</div>
            </Grid>
            <Grid
              style={{
                display: 'flex',
                // justifyContent: 'left',
                padding: '8px',
              }}
              item
              direction='column'
              xs={2}>
              <div>&nbsp;</div>
              <div style={{ fontSize: '1.1em' }}>{email}</div>
            </Grid>
          </Grid>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'left',
                backgroundColor: '#26477c',
                padding: '8px',
                borderRadius: '8px',
              }}
              item
              xs={12}>
              <div>&nbsp;</div>
            </Grid>
          </Grid>
        </ThemeProvider>
      </>
    );
  } else {
    return <>Loading...</>;
  }
};

export default ProfilePage;
